/**
 * GlobalVars
 */
function get() {
  return window.GlobalVars;
}

export default get();



// WEBPACK FOOTER //
// ./js/common/GlobalVars.js